var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class VendorMappingApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'customers';
    }
    createMapping(createVendorMapping) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/${createVendorMapping.customerId}/vendors/${createVendorMapping.vendorId}`,
                data: {
                    vendorKeys: createVendorMapping.vendorKeys,
                    vendorKeyFriendlyNames: createVendorMapping.vendorKeyFriendlyNames,
                },
            });
        });
    }
    updateMapping(updateVendorMapping) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}/${updateVendorMapping.customerId}/vendors/${updateVendorMapping.vendorId}`,
                data: {
                    vendorKeys: updateVendorMapping.vendorKeys,
                    vendorKeyFriendlyNames: updateVendorMapping.vendorKeyFriendlyNames,
                },
            });
        });
    }
    deleteMapping(customerId, vendorId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'DELETE',
                route: `${this.apiBasePath}/${customerId}/vendors/${vendorId}`,
            });
        });
    }
    getCustomerWithVendors(customerId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/${customerId}/vendors`,
                params: params,
            });
        });
    }
}
//# sourceMappingURL=index.js.map